import { getTranslations } from 'next-intl/server';

export function formatTitle (titles: string[]): string {
    return titles.join(' - ');
}

export async function getServerTitle (locale: string, titleKeys: string[]): Promise<string> {
    const t = await getTranslations({ locale: locale, namespace: 'meta.titles' });

    return formatTitle([
        ...titleKeys.map(key => t(key)),
        t('moonOne')
    ]);
}
